import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useEquipmentDetailCodes } from './equipment-code-detail-provider';
import { formSchema } from '../../components/forms/equipment-association-schema';
import AssociationForm from './equipment-code-association-form';
import { determineUpdatableFields } from '../../components/forms/association-specification-fields';

const AssociationEdit = () => {
  const { equipmentAssociation, updateEquipmentAssociation } =
    useEquipmentDetailCodes();

  const {
    formState: { errors },
    control,
    handleSubmit,
    register,
    setValue,
  } = useForm({
    resolver: yupResolver(formSchema),
    mode: 'onBlur',
  });

  const onSubmit = (data) => {
    const { id, standardItemId, equipmentCodeId } = equipmentAssociation;
    const updatableFields = determineUpdatableFields(data);
    updateEquipmentAssociation({
      variables: {
        id: Number(id),
        equipmentAssociation: {
          standardItemId,
          equipmentCodeId,
          ...updatableFields,
        },
      },
    });
  };

  return (
    <form id="association-edit-form" onSubmit={handleSubmit(onSubmit)}>
      <AssociationForm
        control={control}
        errors={errors}
        setValue={setValue}
        register={register}
        updateStandardItemId={() => {}}
        equipmentCodeId="0"
      />
    </form>
  );
};

export default AssociationEdit;
